export interface BasePalette {
	100: string;
	200: string;
}

export interface InfoPalette {
	100: string;
	200: string;
	300: string;
}

export interface NeutralPalette {
	100: string;
	200: string;
	300: string;
	400: string;
	500: string;
}

export interface PrimaryPalette {
	300: string;
	background: string;
}

export interface AccentPalette {
	300: string;
}

export interface Brand {
	accent: AccentPalette;
	primary: PrimaryPalette;
	primaryHover: string;
	primaryDisabled: string;
	secondary: string;
	secondaryHover: string;
	secondaryDisabled: string;
	link: string;
	linkHover: string;
	text: string;
	chatBubble: string;
}

export interface Colors {
	brand: Brand;
	neutral: NeutralPalette;
	success: InfoPalette;
	warning: InfoPalette;
	error: InfoPalette;
	info: BasePalette;
}

export const hexToRgba = (hex: string, alpha?: number): string => {
	if (alpha) {
		const matches = hex.match(/\w\w/g);
		if (!matches) {
			throw new Error('Invalid hex color');
		}
		const [r, g, b] = matches.map((x) => parseInt(x, 16));

		return `rgba(${r}, ${g}, ${b}, ${alpha})`;
	}
	let hasAlpha = false;
	let h: string | number = hex.slice(hex.startsWith('#') ? 1 : 0);
	if (h.length === 3) {
		h = [...h].map((x) => x + x).join('');
	} else if (h.length === 8) {
		hasAlpha = true;
	}
	h = parseInt(h, 16);

	return `rgb${hasAlpha ? 'a' : ''}(${h >>> (hasAlpha ? 24 : 16)}, 
			${(h & (hasAlpha ? 0x00ff0000 : 0x00ff00)) >>> (hasAlpha ? 16 : 8)},
			${(h & (hasAlpha ? 0x0000ff00 : 0x0000ff)) >>> (hasAlpha ? 8 : 0)}${
	hasAlpha ? `, ${h & 0x000000ff}` : ''
})`;
};
